import { ContentCopy } from '@mui/icons-material';
import { Box, Divider, FormControl, IconButton, InputAdornment, OutlinedInput, Stack, Typography } from '@mui/material';
import React, { forwardRef } from 'react';
// eslint-disable-next-line no-unused-vars
const TwoFactoryForm = forwardRef((props, ref) => {
    const { secretKey, qrCode } = props;
    const handleClickClipboard = () => {
        navigator.clipboard.writeText(secretKey);
    };
    return (React.createElement("form", null,
        React.createElement(Stack, { direction: 'row', flexDirection: 'column', alignItems: 'center', sx: (theme) => ({
                padding: theme.spacing(2, 0),
                img: {
                    width: '180px',
                },
            }) },
            React.createElement("img", { src: `data:image/svg+xml;utf8,${encodeURIComponent(qrCode)}` })),
        React.createElement(Box, { component: 'div', sx: (theme) => ({
                margin: theme.spacing(2, 0),
                '.MuiTypography-body1': {
                    marginTop: theme.spacing(2),
                    wordBreak: 'break-all',
                    textAlign: 'center',
                },
                '.MuiTypography-body2': {
                    color: theme.palette.text.secondary,
                },
                '.MuiOutlinedInput-input': {
                    padding: '0!important',
                },
            }) },
            React.createElement(Divider, { textAlign: 'center' },
                React.createElement(Typography, { variant: 'body2' }, "\u0418\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043B\u044E\u0447 \u0432\u0440\u0443\u0447\u043D\u0443\u044E")),
            React.createElement(FormControl, { margin: 'normal', variant: 'outlined', fullWidth: true },
                React.createElement(OutlinedInput, { id: 'outlined-adornment-secret-key', type: 'text', defaultValue: secretKey, fullWidth: true, readOnly: true, multiline: true, endAdornment: React.createElement(InputAdornment, { position: 'end' },
                        React.createElement(IconButton, { edge: 'end', onClick: handleClickClipboard },
                            React.createElement(ContentCopy, { fontSize: 'small' }))) })))));
});
export default TwoFactoryForm;
